<template>

<component :is="(isRedirect) ? 'a' : 'router-link'" :href="href" :to="toFinal">

	<slot></slot>

</component>

</template>

<script>

export default {

	props: ['to'],

    computed: {

        isRedirect: function() {

            if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

                if (this.to.params) {

                    if (this.to.params.type) {

                        if (this.$subdomain.type !== this.to.params.type || this.$subdomain.name !== this.to.params.name) {

                            return this.to.params

                        } else {

                            return false

                        }

                    } else {

                        return false

                    }

                } else {

                    return false

                }

            } else {

                return false

            }

        },

        href: function() {

            if (this.isRedirect) {

                return 'https://geekgroup.app/' + this.isRedirect.type + '/' + this.isRedirect.name

            } else {

                return false

            }

        },

        toFinal: function() {

            if (this.isRedirect) {

                return {}

            } else {

                return this.to

            }

        }

    }

}

</script>

<style scoped>

</style>
